import(/* webpackMode: "eager" */ "/workspace/repo/global-music-ssr/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/repo/global-music-ssr/src/app/artists/component/theme-a.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/repo/global-music-ssr/src/app/artists/component/theme-b.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/repo/global-music-ssr/src/app/artists/component/theme-c.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/repo/global-music-ssr/src/app/artists/component/theme-d.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/repo/global-music-ssr/src/app/artists/component/theme-e.tsx");
